import React, { HtmlHTMLAttributes, StyleHTMLAttributes, useEffect, useState } from 'react';
import styles from './DropdownInput.module.scss';

function DropdownInput(props: DropdownInputProps) {

    return (
        <div className={styles.dropdowninput} style={props.style}>
            <p>{props.title}</p>
                        
            <select
                onChange={props.onChange} 
                value = {props.value}
                onKeyDown={props.onKeyDown}
            >
                {props.children}
            </select>

        </div>
    );
}

class DropdownInputProps {
    onChange?:  ((e: any)=> void)
    onKeyDown?:  ((e: any)=> void)

    title?: string
    value?: string
    children?: Array<React.ReactNode>
    style?: React.CSSProperties
}

export default DropdownInput;